<template>
  <aside :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']">
      <div class="main-navbar logo">
        <nav class="navbar align-items-stretch navbar-light bg-primary flex-md-nowrap border-bottom p-0">
          <a class="navbar-brand w-100 h-100 mr-0" href="#" style="line-height: 25px;">
            <div class="d-table m-auto text-center">
              <img
                id="main-logo"
                class="d-inline-block align-top mr-1"
                style="max-height: 38px; max-width: 80%"
                src="@/assets/images/logo-white.png"
                :alt="$t('sidebar.logoAlt')">
            </div>
          </a>
          <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none text-white" @click="handleToggleSidebar()">
            <i class="material-icons">&#xE5C4;</i>
          </a>
        </nav>
      </div>

      <div class="nav-wrapper">
          <d-nav class="flex-column">
            <sidebar-item
              v-for="(item, index) in menu"
              :key="index"
              :item="item"
              :collapse-id="`sidebar-item-${index}`"
              @toggle-sidebar="handleToggleSidebar"
            />
          </d-nav>
      </div>
  </aside>
</template>

<script>
import Events from '_utils/events';
import SessionService from '_services/common/sessionService';
import SidebarItem from './SidebarItem.vue';

export default {
  name: 'main-sidebar',
  props: {
    /**
      * Whether to hide the logo text, or not.
      */
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    /**
     * The menu items.
     */
    items: {
      type: Array,
      required: true,
    },
  },
  components: {
    SidebarItem,
  },
  computed: {
    menu() {
      return this.items.filter(item => this.modules.includes(item.name) || item.name === 'games' || item.name === 'dashboard');
    },
  },
  data() {
    return {
      sidebarVisible: false,
      modules: [],
    };
  },
  methods: {
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
  },
  created() {
    const { modules } = SessionService.getLocalData('_user');
    this.modules = modules.map(module => module.slug);
    this.$eventHub.$on('toggle-sidebar', this.handleToggleSidebar);
    Events.$on('sidebarVisible', sidebarVisible => { this.sidebarVisible = sidebarVisible; });
  },
  beforeDestroy() {
    this.$eventHub.$off('toggle-sidebar');
  },
};
</script>

<style lang="scss">
  .main-sidebar {
    .item-icon-wrapper {
      display: inline-block;
    }
    .dropdown-menu {
      display: block;
    }
  }
</style>
